export default __webpack_public_path__ + "static/media/img/miso-robotics.webp";